import { z, isoZ } from 'my-zod'
import { customersModel } from '../../customer-operations/customer/customers-model'
import { SelectSubscriptionStatusEnum } from '../customer-subscription'

export const subscriberSystemView = customersModel.augment({
  planName: z.string().nullish().setLabel('Subscription Plan Name'),
  billingServiceSubscriptionId: z.string().nullish(),
  subscriptionStatus: SelectSubscriptionStatusEnum.nullish(),
  activationDate: isoZ.instant().nullish(),
  cancellationDate: isoZ.instant().nullish().setLabel('Subscription Cancellation Date'),
  creditBalance: z.number(),
  creditExpiryDate: isoZ.instant().nullish()
})

export type subscriberSystemView = z.infer<typeof subscriberSystemView>
